import React, { useState, useEffect, useContext } from "react";
import "react-accessible-accordion/dist/fancy-example.css";
import ConsignmentDetails from "./ConsignmentDetails";
import VehicleDetails from "./VehicleDetails";
import { useIndentTracking } from "../../hooks/useIndentTracking";
import useFetchLRDetails from "../../hooks/useFetchLRDetails";

const ViewDetails = ({
  getVehicleTracking = () => { },
  truck_details,
  truck_status,
  indent_id,
  indent_sub_id,
  origin,
  destination,
  lr_ids,
  userDefinedFields = [],
  prefetchedDetails = null,
  readOnly = false,
  defaultTab = "truckDetails",
  hideSubmitButton = false,
  isPlanning = false,
  isRestricted = false,
}) => {
  const [selectedTab, setSelectedTab] = useState(defaultTab);

  const {
    details,
    loading: loadingLrDetails,
    refetch: refetchLRDetails,
  } = useFetchLRDetails({
    indent_id,
    indent_sub_id,
    lr_ids,
    prefetchedDetails,
  });

  const displayLrId =
    details?.display_lr_id || details?.lr_no || details?.lr_id || "";

  const { trackIndentEvent } = useIndentTracking();

  useEffect(() => {
    trackIndentEvent(
      "indent tracking",
      "user has viewed `view truck details` modal",
      `indent id :${indent_id}, indent sub id :${indent_sub_id}`
    );
  }, []);

  return (
    <div>
      {/* <Loader show={show} /> */}
      <div className="text-center mb-4 row px-4">
        <button
          onClick={() => {
            trackIndentEvent("indent tracking", "user has switched to truck details tab", `indent id :${indent_id}, indent sub id :${indent_sub_id}`);
            setSelectedTab("truckDetails")
          }}
          className={`btn btn-outline-info col-md-6 ${selectedTab === "truckDetails" ? "active" : ""
            }`}
        >
          Truck Details{" "}
          <span>
            <i className={`fa fa-truck`} aria-hidden="true"></i>
          </span>
        </button>
        <button
          onClick={() => {
            trackIndentEvent("indent tracking", "user has switched to consignment details tab", `indent id :${indent_id}, indent sub id :${indent_sub_id}`);
            setSelectedTab("consignmentDetails")
          }}
          className={`btn btn-outline-info col-md-6 ${selectedTab === "consignmentDetails" ? "active" : ""
            }`}
        >
          Consignment Details{" "}
          <span>
            <i className={`fa fa-cube`} aria-hidden="true"></i>
          </span>
        </button>
      </div>

      {selectedTab === "truckDetails" && (
        <VehicleDetails
          truckDetails={truck_details}
          truck_status={truck_status}
          lrDetails={details}
          indentId={indent_id}
        />
      )}
      <div
        className={selectedTab === "consignmentDetails" ? "d-block" : "d-none"}
      >
        <ConsignmentDetails
          indent_id={indent_id}
          indent_sub_id={indent_sub_id}
          origin={origin}
          destination={destination}
          lr_ids={lr_ids}
          userDefinedFields={userDefinedFields}
          isRestricted={isRestricted}
          readOnly={readOnly}
          isPlanning={isPlanning}
          details={details}
          getVehicleTracking={getVehicleTracking}
          hideSubmitButton={hideSubmitButton}
          loading={loadingLrDetails}
        />
      </div>
    </div>
  );
};

export default ViewDetails;
